import api from "./axios";

// Upload BRD document (optional epicIssueId scopes document to an Epic in the sprint)
export const uploadBRD = (file, sprintId, epicIssueId) => {
  const formData = new FormData();
  formData.append("file", file);
  if (sprintId) formData.append("sprintId", sprintId);
  if (epicIssueId) formData.append("epicIssueId", epicIssueId);
  return api.post("/ai/upload-brd", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

// Generate task breakdown from BRD
export const generateTasksFromBRD = (data) =>
  api.post("/ai/generate-tasks", data);

// Get draft items for a sprint
export const getDrafts = (sprintId, status) =>
  api.get(`/ai/drafts/${sprintId}${status ? `?status=${status}` : ""}`);

// Approve a draft item
export const approveDraft = (id) =>
  api.put(`/ai/drafts/${id}/approve`);

// Reject a draft item
export const rejectDraft = (id) =>
  api.put(`/ai/drafts/${id}/reject`);

// Bulk approve/reject drafts
export const bulkDraftAction = (ids, action) =>
  api.put("/ai/drafts/bulk", { ids, action });

// Weekly stakeholder-style team report (Team Activity; AI + DB context)
export const generateWeeklyTeamReport = (payload) =>
  api.post("/ai/weekly-team-report", payload);

// Get sprint health analysis
export const getSprintHealth = (sprintId, refresh = false) =>
  api.get(`/ai/sprint/${sprintId}/health${refresh ? "?refresh=true" : ""}`);

// Get sprint metrics (without AI)
export const getSprintMetrics = (sprintId) =>
  api.get(`/ai/sprint/${sprintId}/metrics`);

// Clear all drafts for a sprint
export const clearAllDrafts = (sprintId) => api.delete(`/ai/drafts/sprint/${sprintId}`);

// Get documents for a sprint
export const getSprintDocuments = (sprintId) =>
  api.get(`/ai/documents/${sprintId}`);
